import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from '../../../../../components/TextField';
import Literal from '../../../../../components/Literal';

const propTypes = {
    field: PropTypes.object.isRequired,

    error: PropTypes.string,
    mandatory: PropTypes.bool,
    description: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    focus: PropTypes.bool,
    literal: PropTypes.string,
};

class IntegrationTextField extends Component {
    static defaultProps = {
        hintText: <Literal literal="placeholder_text_field" />,
    };

    constructor(props) {
        super(props);
        this.state = { value: props.value };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        prevProps.focus !== this.props.focus && this.input.focus();
    }

    onChange = (text) => {
        let { onChange, onRemove, field } = this.props;
        if (text) {
            onChange && onChange(field.id, text);
        } else {
            onRemove && onRemove(field.id);
        }
    };

    render() {
        let { field, filter, readOnly, mandatory, description, error, hintText } = this.props;
        let { value } = this.state;

        return (
            <div className="line-form">
                <span className="title-form">
                    <Literal literal={description} /> {mandatory ? '*' : ''}
                </span>
                <TextField
                    error={error}
                    value={value}
                    fullWidth={true}
                    ref={(e) => (this.input = e)}
                    hintText={hintText}
                    style={{ width: 290 }}
                    disabled={readOnly}
                    onChange={this.onChange}
                    filter={filter}
                    showClear={false}
                />
            </div>
        );
    }
}

IntegrationTextField.propTypes = propTypes;

export default IntegrationTextField;
